export const  STUDENT_RELATED_COURSES = "STUDENT_RELATED_COURSES";


export const  ADD_ATTENDANCE_STUDENT = "ADD_ATTENDANCE_STUDENT";